export const contentTableConfig = {
  title: '群列表',
  propList: [
    {prop: 'chatId', label: '群ID', minWidth: '120'},
    {prop: 'chatName', label: '群名称', minWidth: '100'},
    {prop: 'corpId', label: '主体ID', minWidth: '100'},
    {prop: 'corpName', label: '主体名称', minWidth: '100'},
    {prop: 'totalCount', label: '群内总人数', minWidth: '80', sortable: 'custom'},
    {prop: 'replyCount', label: '回复次数', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
